import * as React from "react";
import { connect } from "react-redux";
import { FetchListAction, FetchListPayload, CacheDataAction, CacheDataPayload } from "../../../redux/cache/types";
import { useWindowSize } from "../../../utilities/use-window-size";
import { AppState } from "../../../redux";
import * as Actions from "../../../redux/actions";
import isEmpty from "lodash.isempty";
import { SmallCarousel } from "../../../react-components/panels/pitch-panel/small-carousel";
import { LargeCarousel } from "../../../react-components/panels/pitch-panel/large-carousel";
import { Loader } from "../../../react-components/page/loader";

interface SignUpCarouselProps {
  fixedList: { id: string };
}

interface MapStateProps {
  data: any;
  listId: string;
  showBtn?: boolean;
  isFetching: boolean;
}

interface MapDispatchProps {
  fetchList: (payload: FetchListPayload) => FetchListAction;
  cacheData: (payload: CacheDataPayload) => CacheDataAction;
}

export type Props = SignUpCarouselProps & MapStateProps & MapDispatchProps;

export const Component = (props: Props) => {
  const { data, isFetching, fetchList, listId } = props;

  const list = data?.list?.list;
  const [currentSlideIndex, setCurrentSlideIndex] = React.useState<number>(0);
  const [retries, setRetries] = React.useState<number>(0);
  const [items, setItems] = React.useState(null);
  const windowSize = useWindowSize();
  const screenWidth = windowSize?.width;
  const isSmallScreen = !isNaN(screenWidth) && screenWidth <= 520;
  const isHomeCarousel = listId === "E59ZC9ZFQqmmvyKop_Ghlg";

  React.useEffect(() => {
    const shouldFetchData = !isEmpty(listId) && isEmpty(list) && !isFetching && retries < 3;
    if (shouldFetchData) {
      setRetries(retries + 1);
      fetchList({ variables: { listId } });
    }
  }, [listId, isFetching, fetchList, list, retries, setRetries]);

  React.useEffect(() => {
    if (list?.items?.edges && items === null) {
      const _items = [...list?.items?.edges];
      setItems(_items);
    }
  }, [list, setItems, items]);

  if (!screenWidth) {
    return null;
  }

  const title = items ? items[currentSlideIndex].listItem.item.title : "";

  return (
    <Container
      isSmallScreen={isSmallScreen}
      isPitchPlanet={false}
      isHomeCarousel={true}
      currentSlideIndex={currentSlideIndex}
      setCurrentSlideIndex={setCurrentSlideIndex}
    >
      {items ? (
        isSmallScreen ? (
          <>
            <h1 className="heading">What is on Radivision?</h1>
            <SmallCarousel
              items={items}
              showBtn={false}
              setCurrentSlideIndex={setCurrentSlideIndex}
              currentSlideIndex={currentSlideIndex}
            />
          </>
        ) : (
          <>
            <h1 className="heading">What is on Radivision?</h1>

            <LargeCarousel
              items={items}
              showBtn={false}
              setCurrentSlideIndex={setCurrentSlideIndex}
              currentSlideIndex={currentSlideIndex}
              playMode={"HLS"}
            />
            <div className="carousel-title">
              {title === "BING"
                ? "Interviews"
                : title === "Curated Resources & UGC Content"
                  ? "Curated & Member Content"
                  : title === "Live Interactive Interviews"
                    ? "Interviews + Live Q&A"
                    : title}
            </div>
          </>
        )
      ) : (
        <div className="skeleton-loader" style={{ height: "500px" }}>
          <Loader isActive={true} />
        </div>
      )}
    </Container>
  );
};

const Container = ({
  children,
  isSmallScreen,
  isPitchPlanet,
  isHomeCarousel,
  currentSlideIndex,
  setCurrentSlideIndex,
}) => {
  const carouselRef = React.useRef<HTMLDivElement>(null);

  React.useLayoutEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel || window.innerWidth >= 576) return;
    const video = carousel.querySelector(".slick-current .pitch-video-container");
    const slider = carousel.querySelector(".slick-slider");
    if (!video || !slider) return;
    const alignArrows = () => {
      const rect = video.getBoundingClientRect();
      carousel.style.setProperty("--home-arrow-top", `${rect.top - slider.getBoundingClientRect().top + rect.height / 2}px`);
    };
    alignArrows();
    const observer = new (window as any).ResizeObserver(alignArrows);
    observer.observe(video);
    observer.observe(video.parentElement);
    return () => observer.disconnect();
  }, [children]);

  return (
    <>
      <div
        ref={carouselRef}
        id="pitch_planet"
        className={`${isSmallScreen ? "small-pitch-carousel" : "pitch-carousel"} ${isPitchPlanet ? "is-pitch-planet" : "is-standalone"
          } ${isHomeCarousel ? "is-home-carousel" : ""} `}
      >
        {children}
      </div>
    </>
  );
};
const mapState = (state: AppState, props: SignUpCarouselProps) => {
  const listId = props.fixedList.id;
  const data = state.cache.store[listId];

  return {
    data,
    listId,
    isFetching: state.cache.inProgress[listId],
  };
};

const mapDispatch = {
  fetchList: Actions.fetchList,
  cacheData: Actions.cacheData,
};

export const SignUpCarousel = connect(mapState, mapDispatch)(Component);
